export enum ImageCoverageTableColumnIds {
  CATEGORY_NAME = 'CATEGORY_NAME',
  VENUE_SLUG = 'VENUE_SLUG',
  COVERAGE = 'COVERAGE',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SortState<T> = {
  sortBy: T;
  sortOrder: SortOrder;
};
